import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Image from "react-bootstrap/Image";
import { Link } from "react-router-dom";
import { motion } from "motion/react";
import {
  Shield,
  Settings,
  Database,
  CheckCircle2,
  ArrowRight,
  Layers,
  Globe,
  Code,
  Zap,
  Book,
  FileText,
  Download,
  Phone,
  Code2,
} from "lucide-react";

// Decorative banner shapes to match existing site look
import bannerShape1 from "../assets/images/layers/banner_layer_one.png";
import bannerShape2 from "../assets/images/layers/banner_layer_two.png";
import flutterHero from "../assets/images/flutterApp.jpg";







const FlutterSDK = () => {
  return (
    <>
      <style>{`
@import url('https://fonts.googleapis.com/css2?family=Outfit:wght@100..900&display=swap');              .gcc-outfit { font-family: 'Outfit', ui-sans-serif, system-ui, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, 'Apple Color Emoji', 'Segoe UI Emoji'; }
  
.gcc-outfit  *{ font-family: "Outfit", sans-serif;}

              @keyframes floatY { 0% { transform: translateY(0); } 50% { transform: translateY(-8px); } 100% { transform: translateY(0); } }
              @keyframes floatX { 0% { transform: translateX(0); } 50% { transform: translateX(8px); } 100% { transform: translateX(0); } }
              @keyframes pulseGlow { 0% { box-shadow: 0 8px 24px rgba(0,0,0,0.08); }
                                     50% { box-shadow: 0 12px 28px rgba(0,0,0,0.12); }
                                     100% { box-shadow: 0 8px 24px rgba(0,0,0,0.08); } }
              .shape-float-y { animation: floatY 12s ease-in-out infinite; }
              .shape-float-x { animation: floatX 14s ease-in-out infinite; }
              .card-modern { border-radius: 12px; background: #fff; box-shadow: 0 8px 24px rgba(0,0,0,0.08); transition: transform .25s ease, box-shadow .25s ease; }
              .card-modern:hover { transform: translateY(-4px); animation: pulseGlow 1.6s ease-in-out; }
              .card-icon { width:40px; height:40px; border-radius:50%; display:flex; align-items:center; justify-content:center; background: linear-gradient(135deg,#E2F1FE,#ffffff); border:1px solid #e6f0ff; }
              .card-accent-red { border-top:4px solid #ee0000; }
              .card-accent-blue { border-top:4px solid #2563eb; }
              .card-accent-violet { border-top:4px solid #7c3aed; }
              .badge-pill { display:inline-block; padding:6px 12px; border-radius:999px; font-size:12px; font-weight:600; }
              .badge-prime { background:#ffefef; color:#ee0000; border:1px solid #ee0000; }
              .badge-partner { background:#eef6ff; color:#2563eb; border:1px solid #2563eb; }
              .stat-chip { display:inline-flex; align-items:center; gap:6px; padding:8px 12px; border-radius:999px; background:#f7fbff; border:1px solid #e6f0ff; font-weight:600; font-size:12px; }
              .card-title-lg { font-size: 1.4rem; letter-spacing: -0.02rem; }
              .card-subtitle-sm { font-size: 12px; color: #64748b; font-weight: 600; }
              /* Hero Enhancements */
              .hero-tag { display:inline-flex; align-items:center; gap:8px; padding:6px 12px; border-radius:999px; background:#ffefef; color:#ee0000; border:1px solid #ffd4d4; font-weight:700; font-size:12px; }
              .hero-title { font-weight:800; font-size:42px; line-height:1.1; letter-spacing:-0.02rem; }
              .highlight-red { color:#ee0000;  }
              .hero-chip-row { display:flex; gap:12px; flex-wrap:wrap; margin:18px 0; }
              .hero-media { border-radius:16px; overflow:hidden; 
            //   box-shadow:0 20px 60px rgba(16,24,40,0.12);
               }
              .btn-red { text-decoration:none;background:#ee0000; color:#fff; border:none; border-radius:12px; padding:10px 18px; font-weight:700; box-shadow:0 12px 24px rgba(238,0,0,0.18); }
              .btn-outline-dark { text-decoration:none;background:#fff; color:#0f172a; border:1px solid #e5e7eb; border-radius:12px; padding:10px 18px; font-weight:700; }
              /* Hero Stat Cards (icon chips) */
              .stat-card { display:flex; align-items:center; gap:12px; padding:12px 16px; border-radius:16px; background:#fff; border:1px solid #e6edf5; box-shadow:0 2px 0 rgba(0,0,0,0.04); }
              .stat-icon { width:36px; height:36px; border-radius:12px; display:flex; align-items:center; justify-content:center; border:1px solid transparent; }
              .stat-icon-green { background:#f0fff5; border-color:#d7fbe7; color:#10b981; }
              .stat-icon-orange { background:#fff7ed; border-color:#fde2c5; color:#f59e0b; }
              .stat-icon-pink { background:#fdf2f6; border-color:#f8d7e5; color:#ef4444; }
              .stat-icon-blue { background:#f0f9ff; border-color:#bae6fd; color:#0ea5e9; }
              .stat-label { font-size:12px; color:#64748b; }
              .stat-value { font-size:16px; font-weight:800; color:#0f172a; }

              /* What This SDK Does Section - Advanced Design */
              .sdk-section { position: relative; padding: 80px 0; background-color: #effdff; overflow: hidden; }
              
              /* Grid Pattern */
              .sdk-grid-overlay {
                position: absolute;
                inset: 0;
                background-image: radial-gradient(#e2e8f0 1px, transparent 1px);
                background-size: 32px 32px;
                opacity: 0.6;
                pointer-events: none;
                z-index: 0;
              }

              /* Floating Orbs */
              @keyframes orbBreath {
                0%, 100% { transform: scale(1); opacity: 0.4; }
                50% { transform: scale(1.2); opacity: 0.6; }
              }
              .sdk-orb {
                position: absolute;
                border-radius: 50%;
                filter: blur(80px);
                z-index: 0;
                animation: orbBreath 10s ease-in-out infinite;
              }
              .sdk-orb-1 {
                top: -10%;
                right: -5%;
                width: 400px;
                height: 400px;
                // background: radial-gradient(circle, rgba(238,0,0,0.15) 0%, rgba(255,255,255,0) 70%);
              }
              .sdk-orb-2 {
                bottom: -10%;
                left: -5%;
                width: 300px;
                height: 300px;
                background: radial-gradient(circle, rgba(37,99,235,0.1) 0%, rgba(255,255,255,0) 70%);
                animation-delay: 5s;
              }

              /* Header Elements */
              .sdk-badge {
                display: inline-flex;
                align-items: center;
                gap: 8px;
                padding: 8px 16px;
                background: #fff;
                border: 1px solid #e2e8f0;
                border-radius: 99px;
                box-shadow: 0 2px 10px rgba(0,0,0,0.05);
                font-size: 12px;
                font-weight: 700;
                color: #0f172a;
                text-transform: uppercase;
                letter-spacing: 1px;
                margin-bottom: 24px;
                position: relative;
                z-index: 1;
              }
              .sdk-badge-dot {
                width: 6px;
                height: 6px;
                background-color: #ee0000;
                border-radius: 50%;
                animation: pulseRed 2s infinite;
              }
              @keyframes pulseRed {
                0% { box-shadow: 0 0 0 0 rgba(238, 0, 0, 0.4); }
                70% { box-shadow: 0 0 0 6px rgba(238, 0, 0, 0); }
                100% { box-shadow: 0 0 0 0 rgba(238, 0, 0, 0); }
              }

              .sdk-title { 
                font-size: 42px; 
                font-weight: 800; 
                text-align: center; 
                margin-bottom: 40px; 
                color: #0f172a;
                letter-spacing: -1px;
                position: relative;
                z-index: 1;
              }
              
              .sdk-underline {
                height: 4px;
                background: #ee0000;
                border-radius: 2px;
                margin: 0 auto 60px;
                position: relative;
                z-index: 1;
              }

              /* Card Styling */
              .feature-card {
                background: #fff;
                border-radius: 24px;
                padding: 40px 32px;
                border: 1px solid #f1f5f9;
                box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
                transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
                height: 100%;
                position: relative;
                overflow: hidden;
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                z-index: 1;
              }
              
              /* Card Hover Lift */
              .feature-card:hover {
                transform: translateY(-12px);
                box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.15);
                border-color: #fee2e2;
              }
              
              /* Floating Glow Behind Card (Pseudo) */
              .feature-card::before {
                content: '';
                position: absolute;
                inset: -20px;
                background: radial-gradient(circle at center, rgba(238,0,0,0.08), transparent 70%);
                opacity: 0;
                transition: opacity 0.5s ease;
                z-index: -1;
                filter: blur(20px);
              }
              .feature-card:hover::before { opacity: 1; }

              /* Top Red Strip */
              // .card-strip {
              //   position: absolute;
              //   top: 0;
              //   left: 0;
              //   height: 4px;
              //   background: #ee0000;
              //   z-index: 2;
              // }

              /* Watermark Number */
              .card-watermark {
                position: absolute;
                top: 20px;
                right: 20px;
                font-size: 80px;
                font-weight: 900;
                color: #0f172a;
                opacity: 0.04;
                line-height: 1;
                font-family: 'Outfit', sans-serif;
                z-index: 0;
                pointer-events: none;
              }

              /* Icon Section */
              .feature-icon-wrapper {
                position: relative;
                width: 64px;
                height: 64px;
                margin-bottom: 24px;
                display: flex;
                align-items: center;
                justify-content: center;
                z-index: 1;
              }
              @keyframes rotateBorder {
                from { transform: rotate(0deg); }
                to { transform: rotate(360deg); }
              }
              /* New squircle border to match design */
              .icon-squircle-border {
                position: absolute;
                top: -6px;
                left: -6px;
                width: 76px;
                height: 76px;
                border: 2px solid rgba(238,0,0,0.35);
                border-radius: 22px;
                transform: rotate(45deg);
              }
              .icon-squircle-bg {
                position: absolute;
                inset: 0;
                width: 64px;
                height: 64px;
                border-radius: 16px;
                background: radial-gradient(circle at 40% 40%, rgba(238,0,0,0.12), rgba(238,0,0,0.06) 60%, transparent 70%);
                box-shadow: inset 0 0 20px rgba(238,0,0,0.08);
              }
              .feature-icon-row { display: inline-flex; align-items: center; gap: 12px; }
              
              .feature-icon-inner {
                position: absolute;
                top: 0;
                left: 0;
                width: 64px;
                height: 64px;
                background: transparent;
                border-radius: 16px;
                display: flex;
                align-items: center;
                justify-content: center;
                color: #ee0000;
                transition: transform 0.3s ease, background-color 0.3s ease;
              }
              .feature-card:hover .feature-icon-inner {
                transform: scale(1.1) rotate(5deg);
                background: transparent;
              }

              /* Number Badge */
              .icon-number-dot {
                width: 36px;
                height: 36px;
                border-radius: 50%;
                background: #ffd6d6;
                color: #ee0000;
                font-size: 12px;
                font-weight: 800;
                display: flex;
                align-items: center;
                justify-content: center;
                transition: transform 0.35s ease;
              }
              .feature-card:hover .icon-number-dot { transform: translateX(2px) scale(1.05); }

              /* Text Content */
              .feature-title { font-size: 20px; font-weight: 800; color: #0f172a; margin-bottom: 12px; z-index: 1; position: relative; }
              .feature-desc { font-size: 15px; color: #64748b; line-height: 1.6; margin-bottom: 0px; z-index: 1; position: relative; }

              /* Learn More Link */
              .card-link {
                display: inline-flex;
                align-items: center;
                gap: 6px;
                font-size: 14px;
                font-weight: 700;
                color: #ee0000;
                text-decoration: none;
                position: relative;
                z-index: 1;
                transition: color 0.3s;
                margin-top: auto;
              }
              .card-link svg { transition: transform 0.3s ease; }
              .card-link:hover svg { transform: translateX(4px); }

              /* Bottom Corner SVG */
              .card-corner-shape {
                position: absolute;
                bottom: 0;
                right: 0;
                width: 80px;
                height: 80px;
                opacity: 0;
                transition: opacity 0.5s ease;
                z-index: 0;
                pointer-events: none;
              }
              .feature-card:hover .card-corner-shape { opacity: 1; }

              /* Footer Dots */
              .sdk-footer-dots { display: flex; justify-content: center; gap: 12px; margin-top: 60px; }
              .sdk-dot { width: 10px; height: 10px; background: #e2e8f0; border-radius: 50%; }

              /* Why Choose Us Section (inspired by GlobalCapabilityCenter) */
              .why-section { position: relative; padding: 80px 0; background: #fff; overflow: hidden; }
              .why-grid-overlay {
                position: absolute; inset: 0; pointer-events: none; z-index: 0;
                display: none;
                background-image:
                  radial-gradient(circle at 40px 40px, rgba(2,132,199,0.08), transparent 70px),
                  linear-gradient(0deg, rgba(2,132,199,0.06) 1px, transparent 1px),
                  linear-gradient(90deg, rgba(2,132,199,0.06) 1px, transparent 1px);
                background-size: 140px 140px, 24px 24px, 24px 24px;
                background-position: center;
              }
              .why-badge {
              margin-bottom:24px;
                display: inline-flex; align-items: center; gap: 8px; padding: 8px 18px; border-radius: 999px;
                font-weight: 700; font-size: 13px; letter-spacing: 0.04em; color: #0f172a; background: #ffffff;
                box-shadow: 0 10px 24px -12px rgba(2,132,199,0.35), inset 0 -2px 0 rgba(2,132,199,0.1);
              }
              .why-title { font-size: 42px; font-weight: 800; color: #0f172a; letter-spacing: 0.02em;margin-bottom: 24px; }
              .why-underline { width: 120px; height: 6px; border-radius: 6px; margin: 16px auto 0; background: linear-gradient(90deg,#ef4444,#2563eb); }
              .why-sub { max-width: 980px; margin: 18px auto 0; color: #374151; font-size: 18px; line-height: 30px; }

              /* Central ring emblem */
              .why-ring { position: relative; width: 96px; height: 96px; margin: 26px auto; }
              .why-ring::before { content:""; position:absolute; inset:0; border-radius:50%; border:3px solid rgba(2,132,199,0.25); box-shadow: 0 10px 24px -12px rgba(2,132,199,0.35); }
              .why-ring::after { content:""; position:absolute; inset:12px; border-radius:50%; border:3px dashed rgba(239,68,68,0.5); animation: whyRingSpin 10s linear infinite; }
              @keyframes whyRingSpin { to { transform: rotate(360deg); } }
              .why-ring-core { position:absolute; inset:22px; border-radius:50%; background: #0ea5e9; display:flex; align-items:center; justify-content:center; color:#fff; box-shadow: 0 10px 20px -10px rgba(14,165,233,0.55);}   

              /* Cards */
              .why-card { position: relative; background:#fff; border-radius: 18px; border:1px solid #e5e7eb; box-shadow: 0 18px 40px -24px rgba(2,132,199,0.35); padding: 22px; transition: transform 280ms ease, box-shadow 280ms ease; }
              // .why-card::before { content:""; position:absolute; left:0; right:0; top:0; height:4px; border-top-left-radius:18px; border-top-right-radius:18px; background:#ef4444; }
              .why-card:hover { transform: translateY(-3px); box-shadow: 0 26px 50px -20px rgba(239,68,68,0.35); }
              .why-icon-chip { width:52px; height:52px; border-radius: 14px; background: radial-gradient(120px 120px at 30% 30%, #fee2e2 0%, #fff 70%); color:#ef4444; display:flex; align-items:center; justify-content:center; box-shadow: 0 16px 24px -16px rgba(239,68,68,0.65); }
              .why-card-title { margin-top:24px; font-weight:700; color:#0f172a; font-size: 18px; margin: 15px 0 0 0; }
              .why-card-text { color:#374151; font-size:15px; margin: 4px 0 0; }

              .usecases-section { position: relative; padding: 90px 0; background: #fff; overflow: hidden; }
              .uc-grid-overlay { position: absolute; inset: 0; background-image: radial-gradient(#eaeef5 1px, transparent 1px); background-size: 20px 20px; opacity: 0.45; pointer-events: none; z-index: 0; }
              @keyframes breathX { 0% { transform: translateX(0) scale(1); opacity: .35; } 50% { transform: translateX(16px) scale(1.08); opacity: .5; } 100% { transform: translateX(0) scale(1); opacity: .35; } }
              .uc-orb { position: absolute; border-radius: 50%; filter: blur(60px); z-index: 0;  animation: breathX 12s ease-in-out infinite; }
              .uc-orb.uc-orb-1 { top: -10%; left: 15%; width: 320px; height: 320px; }
              .uc-orb.uc-orb-2 { bottom: -12%; right: -8%; width: 380px; height: 380px; }
              @keyframes spin360 { to { transform: rotate(360deg); } }
              .uc-rotating-square { position: absolute; top: 26px; left: 26px; width: 64px; height: 64px; border: 2px solid rgba(238,0,0,0.35); border-radius: 14px; animation: spin360 15s linear infinite, floatY 8s ease-in-out infinite; opacity: .25; z-index: 0; }
              @keyframes underlineGrow { 0% { width: 0; opacity: .9; } 100% { width: 140px; opacity: 1; } }
              .sdk-underline.uc-underline { width: 0; animation: underlineGrow .8s ease-out forwards; }
              .uc-card { background: #fff; border-radius: 24px; padding: 32px; border: 1px solid #f1f5f9; box-shadow: 0 4px 6px -1px rgba(0,0,0,0.05); transition: all .5s cubic-bezier(0.4,0,0.2,1); position: relative; overflow: hidden; }
              // .uc-card { border-left: 4px solid #ee0000; }
              // .uc-vertical-accent { position: absolute; top: 0; left: 0; width: 4px; height: 100%; background: #ee0000; transform-origin: top; transform: scaleY(0); animation: growY 1s ease forwards; }
              // @keyframes shineSweep { 0% { transform: translateX(-120%); } 50% { transform: translateX(0%); } 100% { transform: translateX(120%); } }
              .uc-card::after { content: ""; position: absolute; inset: 0; background: linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,.6) 50%, rgba(255,255,255,0) 100%); transform: translateX(-120%); pointer-events: none;  mix-blend-mode: soft-light; }
              .uc-card:hover { transform: translateY(-8px); box-shadow: 0 28px 40px -18px rgba(238,0,0,0.22); border-color: #fee2e2; }
              .uc-card:hover .feature-title { color: #ee0000; }
              .uc-number-badge { position: absolute; top: 14px; right: 14px; padding: 6px 10px; border-radius: 999px; background: #fff5f5; color: #ee0000; font-weight: 800; font-size: 12px; border: 1px solid #ffe0e0; box-shadow: 0 8px 16px rgba(238,0,0,0.08); z-index: 2; }
              .icon-squircle-border { animation: rotateBorder 15s linear infinite; }
              @keyframes pulseIcon { 0%,100% { transform: scale(1); opacity: .7; } 50% { transform: scale(1.08); opacity: 1; } }
              .icon-squircle-bg { animation: pulseIcon 4s ease-in-out infinite; }
              @keyframes iconSpin { to { transform: rotate(360deg); } }
              .uc-card:hover .feature-icon-inner { animation: iconSpin .6s ease-in-out; transform: scale(1.1); }
              .sdk-footer-dots .sdk-dot { animation: dotPulse 1.6s ease-in-out infinite; }
              @keyframes dotPulse { 0%,100% { transform: scale(.9); opacity: .6; } 50% { transform: scale(1); opacity: 1; } }
              .sdk-footer-dots .sdk-dot:nth-child(2) { animation-delay: .2s; }
              .sdk-footer-dots .sdk-dot:nth-child(3) { animation-delay: .4s; }

              .resources-section { position: relative; padding: 90px 0; background: #fff; overflow: hidden; }
              .res-grid-overlay { position: absolute; inset: 0; background-image: radial-gradient(#eaeef5 1px, transparent 1px); background-size: 22px 22px; opacity: .45; pointer-events:none; z-index:0; }
              @keyframes resOrbMove { 0% { transform: translate(0,0) scale(1); opacity:.35; } 33% { transform: translate(16px,-8px) scale(1.06); opacity:.5; } 66% { transform: translate(-10px,12px) scale(1.02); opacity:.45; } 100% { transform: translate(0,0) scale(1); opacity:.35; } }
              .res-orb { position:absolute; border-radius:50%; filter: blur(60px); z-index:0; animation: resOrbMove 12s ease-in-out infinite; }
              .res-orb.res-orb-1 { top:-8%; left: 10%; width:300px; height:300px; }
              .res-orb.res-orb-2 { bottom:-12%; right:-8%; width:360px; height:360px; }
              @keyframes floatDiag { 0% { transform: translate(0,0) scale(1); } 50% { transform: translate(12px,-12px) scale(1.06); } 100% { transform: translate(0,0) scale(1); } }
              .res-floating-circle { position:absolute; top: 16%; right: 12%; width: 110px; height: 110px; border: 2px solid rgba(238,0,0,0.35); border-radius: 50%; animation: floatDiag 9s ease-in-out infinite, pulseCircle 6s ease-in-out infinite; opacity:.35; z-index:0; }
              .res-rotating-square { position:absolute; top: 28px; left: 34px; width: 70px; height: 70px; border: 2px solid rgba(238,0,0,0.35); border-radius: 16px; animation: spin360 16s linear infinite, pulseSquare 7s ease-in-out infinite; opacity:.25; z-index:0; }
              .sdk-underline.res-underline { width: 0; animation: underlineGrow .8s ease-out forwards; }
              .res-card { background:#fff; border-radius:24px; padding:26px; border:1px solid #f1f5f9; box-shadow:0 4px 6px -1px rgba(0,0,0,0.05); transition: transform .35s ease, box-shadow .35s ease, border-color .35s ease; position:relative; overflow:hidden;}
              .res-card:hover { transform: translateY(-10px) scale(1.04); box-shadow:0 32px 46px -22px rgba(238,0,0,0.28); border-color:#fee2e2; }
              .res-card:hover .feature-title { color:#ee0000; }
              @keyframes growX { 0% { transform: scaleX(0); } 100% { transform: scaleX(1); } }
              .res-top-accent { position:absolute; top:0; left:0; height:4px; width:100%; transform-origin:left; transform: scaleX(0); animation: growX 1s ease forwards; }
              .res-card::before { content:""; position:absolute; inset:-20px; background: radial-gradient(240px 120px at 30% 30%, rgba(238,0,0,0.18), transparent 70%); opacity:0; filter: blur(18px); transition: opacity .35s ease; z-index:0; }
              .res-card:hover::before { opacity:1; }
              .res-number-badge { position:absolute; top:14px; right:14px; padding:6px 10px; border-radius:999px; background:#fff5f5; color:#ee0000; font-weight:800; font-size:12px; border:1px solid #ffe0e0; box-shadow:0 8px 16px rgba(238,0,0,0.08); z-index:2; }
              .res-icon-wrapper { position:relative; width:56px; height:56px; margin-bottom:14px; display:flex; align-items:center; justify-content:center; }
              .res-icon-bg { position:absolute; inset:0; border-radius:14px; background: #ee0000; box-shadow: 0 16px 30px -12px rgba(238,0,0,0.55); }
              .res-icon-glow { position:absolute; inset:-8px; border-radius:18px; box-shadow: 0 0 0 0 rgba(238,0,0,0.35); animation: pulseIcon 4s ease-in-out infinite; filter: blur(6px); }
              .res-icon-ring { position:absolute; inset:-6px; border-radius:16px; border: 2px solid rgba(238,0,0,0.35); animation: spin360 13s linear infinite, pulseSquare 7s ease-in-out infinite; }
              .res-icon-inner { position:relative; width:56px; height:56px; display:flex; align-items:center; justify-content:center; color:#fff; transition: transform .4s ease; }
              .res-card:hover .res-icon-inner { transform: rotate(360deg) scale(1.1); }
              .res-view { display:inline-flex; align-items:center; gap:6px; font-weight:700; color:#ee0000; opacity:0; transform: translateX(-6px); transition: all .35s ease; }
              .res-card:hover .res-view { opacity:1; transform: translateX(0); }
              .card-corner-left { position:absolute; bottom:0; left:0; width:80px; height:80px; opacity:0; transition: opacity .35s ease; z-index:0; pointer-events:none; }
              .res-card:hover .card-corner-left { opacity:1; }
              /* Responsive column for resources grid */
              .res-col { flex: 0 0 100%; max-width: 100%; }
              @media (min-width: 576px) { .res-col { flex: 0 0 50%; max-width: 50%; } }
              @media (min-width: 768px) { .res-col { flex: 0 0 33.3333%; max-width: 33.3333%; } }
              @media (min-width: 992px) { .res-col { flex: 0 0 25%; max-width: 25%; } }
              @media (min-width: 1200px) { .res-col { flex: 0 0 20%; max-width: 20%; } }
              .res-mini-dots { position:absolute; right:14px; bottom:12px; display:flex; gap:6px; }
              .res-mini-dots .dot { width:6px; height:6px; background:#ee0000; border-radius:50%; opacity:.65; }
              .benefits-section { position: relative; padding: 90px 0; background: #e2f1fe; overflow: hidden; }
              .benefit-grid-overlay { position: absolute; inset: 0; background-image: radial-gradient(#eaeef5 1px, transparent 1px); background-size: 22px 22px; opacity: .45; pointer-events: none; z-index: 0; }
              @keyframes breathMove { 0% { transform: translate(0,0) scale(1); opacity:.35; } 50% { transform: translate(14px,-8px) scale(1.08); opacity:.55; } 100% { transform: translate(0,0) scale(1); opacity:.35; } }
              .benefit-orb { position: absolute; border-radius: 50%; filter: blur(60px); z-index: 0; animation: breathMove 12s ease-in-out infinite; }
              .benefit-orb.benefit-orb-1 { top: -8%; left: 12%; width: 320px; height: 320px; }
              .benefit-orb.benefit-orb-2 { bottom: -12%; right: -10%; width: 380px; height: 380px; }
              .benefit-floating-circle { position: absolute; bottom: 18%; right: 8%; width: 110px; height: 110px; border: 2px solid rgba(238,0,0,0.35); border-radius: 50%; animation: floatY 9s ease-in-out infinite, pulseCircle 6s ease-in-out infinite; opacity:.35; z-index:0; }
              @keyframes pulseCircle { 0%,100% { transform: scale(1); } 50% { transform: scale(1.06); } }
              .benefit-rotating-square { position: absolute; top: 28px; left: 34px; width: 70px; height: 70px; border: 2px solid rgba(238,0,0,0.35); border-radius: 16px; animation: spin360 16s linear infinite, pulseSquare 7s ease-in-out infinite; opacity:.25; z-index:0; }
              @keyframes pulseSquare { 0%,100% { transform: scale(1); } 50% { transform: scale(1.06); } }
              .sdk-underline.benefit-underline { width: 0; animation: underlineGrow .8s ease-out forwards; }
              .benefit-card { background:#fff; border-radius:24px; padding:32px; border:1px solid #f1f5f9; box-shadow:0 4px 6px -1px rgba(0,0,0,0.05); transition: all .5s cubic-bezier(0.4,0,0.2,1); position: relative; overflow:hidden }
              @keyframes growX { 0% { transform: scaleX(0); } 100% { transform: scaleX(1); } }
              .benefit-top-accent { position:absolute; top:0; left:0; height:4px; width:100%;  transform-origin:left; transform: scaleX(0); animation: growX 1s ease forwards; }
              .benefit-card::after { content:""; position:absolute; inset:0; background: linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,.6) 50%, rgba(255,255,255,0) 100%); transform: translateX(-120%); pointer-events:none; animation: shineSweep 3s linear infinite; mix-blend-mode: soft-light; }
              .benefit-card:hover { transform: translateY(-12px); box-shadow: 0 32px 46px -22px rgba(238,0,0,0.28); border-color:#fee2e2; }
              .benefit-card:hover .feature-title { color:#ee0000; }
              .benefit-number-badge { position:absolute; top:14px; right:14px; padding:6px 10px; border-radius:999px; background:#fff5f5; color:#ee0000; font-weight:800; font-size:12px; border:1px solid #ffe0e0; box-shadow:0 8px 16px rgba(238,0,0,0.08); z-index:2; }
              .benefit-icon-wrapper { position: relative; width: 56px; height: 56px; margin-bottom: 18px; display:flex; align-items:center; justify-content:center; }
              .benefit-icon-bg { position:absolute; inset:0; border-radius:50%; background: #e00; box-shadow: 0 16px 30px -12px rgba(238,0,0,0.55); }
              .benefit-icon-glow { position:absolute; inset:-8px; border-radius:50%; box-shadow: 0 0 0 0 rgba(238,0,0,0.35); animation: pulseIcon 4s ease-in-out infinite; }
              .icon-ring-border { position:absolute; inset:-8px; border-radius:50%; border: 2px solid rgba(238,0,0,0.35); animation: spin360 15s linear infinite, pulseSquare 7s ease-in-out infinite; }
              .benefit-icon-inner { position:relative; width:56px; height:56px; display:flex; align-items:center; justify-content:center; color:#fff; transition: transform .4s ease; }
              .benefit-card:hover .benefit-icon-inner { transform: rotate(360deg) scale(1.15); }
              .benefit-mini-dots { position:absolute; left:14px; bottom:12px; display:flex; gap:6px; }
              .benefit-mini-dots .dot { width:6px; height:6px; background:#ee0000; border-radius:50%; opacity:.65; }

              .team-section { position: relative; padding: 90px 0; background: #e2f1fe; overflow: hidden; }
              .team-grid-overlay { position: absolute; inset: 0; background-image: radial-gradient(#eaeef5 1px, transparent 1px); background-size: 22px 22px; opacity: .35; pointer-events: none; z-index: 0; }
              @keyframes teamOrbMove { 0% { transform: translate(0,0) scale(1); } 33% { transform: translate(16px,-10px) scale(1.08); } 66% { transform: translate(-12px,12px) scale(0.96); } 100% { transform: translate(0,0) scale(1); } }
              .team-orb { position:absolute; border-radius:50%; filter: blur(80px); z-index:0;  animation: teamOrbMove 12s ease-in-out infinite; }
              .team-orb-1 { top:-8%; right:-6%; width:380px; height:380px; }
              .team-orb-2 { bottom:-8%; left:-6%; width:320px; height:320px; animation-delay: 2s; }
              @keyframes teamVerticalFloat { 0% { transform: translateY(0) scale(1); } 50% { transform: translateY(-12px) scale(1.06); } 100% { transform: translateY(0) scale(1); } }
              .team-floating-circle { position:absolute; left:6%; top:28%; width:90px; height:90px; border-radius:50%; border:2px solid rgba(238,0,0,.25); animation: teamVerticalFloat 9s ease-in-out infinite; z-index:0; opacity:.45; }
              @keyframes teamSquareRotateScale { 0% { transform: rotate(0deg) scale(1); } 100% { transform: rotate(360deg) scale(1.06); } }
              .team-rotating-square { position:absolute; right:10%; bottom:18%; width:110px; height:110px; border:2px solid rgba(238,0,0,.25); border-radius:12px; animation: teamSquareRotateScale 15s linear infinite; z-index:0; opacity:.35; }
              .sdk-underline.team-underline { margin: 0 auto 40px; }
              .team-card { position:relative; background:#fff; border-radius:18px; border:1px solid #f1f5f9; box-shadow:0 6px 16px rgba(0,0,0,.06); transition: transform .35s cubic-bezier(0.4,0,0.2,1), box-shadow .35s cubic-bezier(0.4,0,0.2,1); overflow:hidden; display:flex; align-items:center; gap:16px; padding:24px 24px; z-index:1; }
              .team-card:hover { transform: translateY(-8px) scale(1.02); box-shadow: 0 30px 50px -20px rgba(238,0,0,.25); border-color:#fee2e2; }
              .team-left-accent { position:absolute; left:0; top:0; width:4px; height:0; background:#ee0000; z-index:2; animation: accentGrow .7s ease forwards; }
              // @keyframes accentGrow { 0% { height:0; } 100% { height:100%; } }
              .team-card::after { content:""; position:absolute; inset:0; background: linear-gradient(120deg, rgba(238,0,0,.06), transparent 60%); opacity:0; transition: opacity .4s ease; z-index:0; }
              .team-card:hover::after { opacity:1; }
              .team-icon-wrapper { position:relative; width:56px; height:56px; border-radius:50%; display:flex; align-items:center; justify-content:center; }
              .team-icon-bg { position:absolute; inset:0; border-radius:50%; background: radial-gradient(120px 120px at 30% 30%, #ee0000 0%, #ff4d4d 70%); box-shadow: 0 16px 30px -12px rgba(238,0,0,0.55); }
              .team-icon-glow { position:absolute; inset:-6px; border-radius:50%; filter: blur(8px); box-shadow: 0 0 0 0 rgba(238,0,0,0.35); animation: pulseIcon 4s ease-in-out infinite; }
              .team-icon-ring { position:absolute; inset:-6px; border-radius:50%; border: 2px solid rgba(238,0,0,0.35); animation: spin360 14s linear infinite; }
              @keyframes spin360 { to { transform: rotate(360deg); } }
              .team-icon-inner { position:relative; width:56px; height:56px; display:flex; align-items:center; justify-content:center; color:#fff; transition: transform .5s ease; }
              .team-card:hover .team-icon-inner { transform: rotate(360deg) scale(1.12); }
              .team-title-text { font-size: 18px; font-weight: 800; color: #0f172a; transition: color .3s ease; }
              .team-card:hover .team-title-text { color: #ee0000; }
              .team-number-badge { position:absolute; top:12px; right:12px; padding:6px 10px; border-radius:999px; background:#fff5f5; color:#ee0000; font-weight:800; font-size:12px; border:1px solid #ffe0e0; box-shadow:0 8px 16px rgba(238,0,0,0.08); z-index:2; }
              .team-corner-shape { position:absolute; bottom:0; right:0; width:80px; height:80px; opacity:0; transition: opacity .5s ease; z-index:0; pointer-events:none; }
              .team-card:hover .team-corner-shape { opacity:1; }
              .team-shine { position:absolute; top:0; left:-40%; width:40%; height:100%; background: linear-gradient(90deg, rgba(255,255,255,0), rgba(255,255,255,.35), rgba(255,255,255,0)); transform: skewX(-20deg); animation: shineSweep 2.8s linear infinite; opacity:.25; pointer-events:none; }
              @keyframes shineSweep { 0% { left:-40%; } 100% { left:110%; } }
              .team-mini-dots { position:absolute; left:14px; bottom:12px; display:flex; gap:6px; }
              .team-mini-dots .dot { width:6px; height:6px; background:#ee0000; border-radius:50%; opacity:.65; }
              .team-card::before { content:""; position:absolute; inset:-20px; background: radial-gradient(circle at center, rgba(238,0,0,0.08), transparent 70%); opacity:0; transition: opacity .5s ease; z-index:-1; filter: blur(20px); }
              .team-card:hover::before { opacity:1; }

              .cta-section { position: relative; padding: 80px 0 90px;  overflow: hidden; }
              .cta-orb { position:absolute; border-radius:50%; filter: blur(60px); background: radial-gradient(circle, rgba(0,0,0,0.04), transparent 70%); z-index:0; }
              .cta-orb-left { left: -60px; top: 30%; width: 220px; height: 220px; }
              .cta-orb-right { right: -60px; top: 18%; width: 220px; height: 220px; }
              .cta-title { font-size: 42px; font-weight: 800; color: #000; text-align:center; }
              .cta-sub { font-size: 18px; color: #2c4a66; text-align:center; max-width: 820px; margin: 10px auto 0; opacity:.9; }
              .cta-buttons { display:flex; gap:12px; justify-content:center; margin-top: 24px; flex-wrap:wrap; }
              .btn-cta-red { display:inline-flex; align-items:center; gap:8px; padding:5px 24px; border-radius:999px; background:#ee0000; color:#fff; font-weight:800; border:none; box-shadow:0 20px 40px -20px rgba(238,0,0,0.65); }
              .btn-cta-outline { display:inline-flex; align-items:center; gap:8px; padding:10px 24px; border-radius:999px; background:#fff; color:#ee0000; font-weight:800; border:2px solid #ee0000; box-shadow:0 12px 24px -12px rgba(238,0,0,0.25); }
              .btn-cta-outline:hover { background:#fff5f5; }
              .btn-cta-red:hover { filter: brightness(1.02); }
              .cta-badge { display:inline-flex; align-items:center; gap:8px; padding:8px 16px; background:#fff; border:1px solid #e2e8f0; border-radius:99px; box-shadow:0 2px 10px rgba(0,0,0,0.05); font-size:12px; font-weight:700; color:#0f172a; text-transform:uppercase; letter-spacing:1px; margin-bottom: 24px; position: relative; z-index: 1; }
              .cta-underline { height: 4px; background: #ee0000; border-radius:2px; margin: 10px auto 0; width: 0; }

              @media (max-width: 991px) {
                 .hero-media { margin-top: 20px !important; }
               }
            `}</style>
      <div className="gcc-outfit">
        <header className="masthead z-0 pt-5 pb-5">
          <div className="container">
            <Image
              src={bannerShape1}
              className="z-n1 position-absolute top-0 end-0 opacity-25 w-40 d-none d-md-block"
              alt="decorative"
            />
            <Row className="align-items-center justify-content-between">
              <Col lg="7">
                <div className="pe-3">
                  <div className="hero-tag mb-3">
                    Seamless Flutter Connectivity with Salesforce MCP
                  </div>
                  <h1 className="hero-title text-black mb-2">
                    Build real-time, personalized{" "}
                    <span className="highlight-red">Flutter applications</span>
                  </h1>
                  <p className="text-black ls-minus-045 fw-700 fs-5 mb-3">
                    using a production-ready SDK that connects to Salesforce MCP
                    through a secure, middleware-backed layer.
                  </p>

                  <p className="mt-2 mb-3 lh-base">
                    Enable live data sync, unified customer sessions, and
                    event-driven engagement—without fragile point-to-point
                    integrations.
                  </p>

                  {/* Key Highlights */}
                  <div className="hero-chip-row">
                    <div className="stat-card">
                      <div className="stat-icon stat-icon-green">
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="currentColor"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M12 2l7 4v6c0 5-3.8 9.4-7 10-3.2-.6-7-5-7-10V6l7-4z" />
                        </svg>
                      </div>
                      <div>
                        <div className="stat-label">Sync</div>
                        <div className="stat-value">Real-time Data</div>
                      </div>
                    </div>
                    <div className="stat-card">
                      <div className="stat-icon stat-icon-orange">
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="currentColor"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
                        </svg>
                      </div>
                      <div>
                        <div className="stat-label">Identity</div>
                        <div className="stat-value">Unified Sessions</div>
                      </div>
                    </div>
                    <div className="stat-card">
                      <div className="stat-icon stat-icon-pink">
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="currentColor"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
                        </svg>
                      </div>
                      <div>
                        <div className="stat-label">Architecture</div>
                        <div className="stat-value">Secure Middleware</div>
                      </div>
                    </div>
                    <div className="stat-card">
                      <div className="stat-icon stat-icon-blue">
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="currentColor"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z" />
                        </svg>
                      </div>
                      <div>
                        <div className="stat-label">Performance</div>
                        <div className="stat-value">Lightweight SDK</div>
                      </div>
                    </div>
                  </div>

                  <div className="d-flex gap-3 mt-4">
                    <Link to="/contact" className="btn-red">
                      Request SDK Access
                    </Link>
                    <Link to="/contact" className="btn-outline-dark">
                      View Integration Guide
                    </Link>
                  </div>
                </div>
              </Col>
              <Col lg="5" className="text-center">
                <Image
                  src={flutterHero}
                  className="m-auto hero-media"
                  style={{ width: "90%" }}
                  alt="Flutter SDK hero"
                />
              </Col>
            </Row>
            <Image
              src={bannerShape2}
              className="position-absolute bottom-0 end-0 w-40 d-none d-md-block bannerShapeBottom"
              alt="decorative"
            />
          </div>
        </header>

        {/* What This SDK Does Section */}
        <section className="sdk-section">
          {/* Background Effects */}
          <div className="sdk-grid-overlay"></div>
          <div className="sdk-orb sdk-orb-1"></div>
          <div className="sdk-orb sdk-orb-2"></div>

          <Container>
            {/* Header */}
            <div
              className="text-center position-relative"
              style={{ zIndex: 2 }}
            >
              <motion.div className="sdk-badge">
                <span className="sdk-badge-dot"></span> Core Capabilities
              </motion.div>

              <motion.h2 className="sdk-title">What This SDK Does</motion.h2>
            </div>

            <Row>
              {[
                {
                  title: "Secure Connection",
                  desc: "Connects Flutter apps to Salesforce MCP securely",
                  icon: Shield,
                  delay: 0.1,
                  num: "01",
                },
                {
                  title: "Backend Abstraction",
                  desc: "Abstracts backend complexity from the application",
                  icon: Settings,
                  delay: 0.2,
                  num: "02",
                },
                {
                  title: "Data Standardization",
                  desc: "Standardizes data access across enterprise systems",
                  icon: Database,
                  delay: 0.3,
                  num: "03",
                },
                {
                  title: "Governed Integration",
                  desc: "Enables governed, observable integrations",
                  icon: CheckCircle2,
                  delay: 0.4,
                  num: "04",
                },
              ].map((item, index) => (
                <Col lg={3} md={6} className="mb-4" key={index}>
                  <motion.div className="h-100">
                    <div className="feature-card group">
                      {/* Top Red Strip */}
                      <div
                        className="card-strip"
                        style={{
                          position: "absolute",
                          top: 0,
                          left: 0,
                          height: 4,
                          width: "100%",
                          zIndex: 2,
                        }}
                      />

                      {/* Watermark */}
                      <div className="card-watermark">{item.num}</div>

                      {/* Icon Section (squircle border + number dot) */}
                      <div className="feature-icon-row">
                        <div className="feature-icon-wrapper">
                          <div className="icon-squircle-border"></div>
                          <div className="icon-squircle-bg"></div>
                          <div className="feature-icon-inner">
                            <item.icon size={26} strokeWidth={2.2} />
                          </div>
                        </div>
                        {/* <div className="icon-number-dot">{item.num}</div> */}
                      </div>

                      {/* Content */}
                      <h3 className="feature-title">{item.title}</h3>
                      <p className="feature-desc">{item.desc}</p>

                      {/* Learn More Link */}

                      {/* Bottom Corner SVG */}
                      <svg
                        className="card-corner-shape"
                        viewBox="0 0 100 100"
                        preserveAspectRatio="none"
                      >
                        <path
                          d="M100 100 V 50 Q 100 100 50 100 H 100 Z"
                          fill="#ffefef"
                        />
                        <path
                          d="M100 100 L 100 40 Q 90 90 40 100 L 100 100 Z"
                          fill="#ffe5e5"
                          opacity="0.5"
                        />
                      </svg>
                    </div>
                  </motion.div>
                </Col>
              ))}
            </Row>
          </Container>
        </section>

        {/* Why Choose Us */}
        <section className="why-section">
          <div className="why-grid-overlay" />
          <Container>
            <div
              className="text-center"
              style={{ position: "relative", zIndex: 1 }}
            >
              <motion.div className="sdk-badge">
                <span className="sdk-badge-dot"></span> WHY CHOOSE US
              </motion.div>
              <motion.h2 className="why-title">
                Why Use Comsense Flutter SDK?
              </motion.h2>

              <motion.p className="why-sub">
                Modern Flutter applications often need to interact with multiple
                backend systems—CRMs, analytics tools, commerce platforms, file
                systems, and legacy applications. Direct integration increases
                coupling, security risk, and maintenance overhead.
              </motion.p>

              <motion.p className="why-sub">
                Comsense Flutter SDK, combined with the Custom Middleware
                Platform, provides a centralized integration model that:
              </motion.p>
            </div>

            <Row
              className="mt-3 justify-content-center"
              style={{ position: "relative", zIndex: 1 }}
            >
              {[
                {
                  title: "Shields applications from backend changes",
                  icon: Shield,
                },
                {
                  title: "Ensures consistent data access patterns",
                  icon: Database,
                },
                {
                  title: "Improves security and compliance",
                  icon: CheckCircle2,
                },
                {
                  title: "Enables faster application evolution",
                  icon: Settings,
                },
              ].map((item, idx) => (
                <Col key={idx} md={3} lg={3} className="mb-4">
                  <motion.div className="why-card h-100" whileHover={{ y: -4 }}>
                    <div
                      style={{
                        display: "block",
                        gap: 14,
                        marginBottom: "15px",
                      }}
                    >
                      <div className="why-icon-chip">
                        <item.icon size={24} strokeWidth={2.2} />
                      </div>
                      <div>
                        <div className="why-card-title">{item.title}</div>
                      </div>
                    </div>
                  </motion.div>
                </Col>
              ))}
            </Row>
          </Container>
        </section>

        {/* Key Capabilities */}
        <style>
          {" "}
          {`
          .caps-section { position: relative; padding: 80px 0 80px; background: #e2f1fe; overflow: hidden; }
          .caps-grid-overlay { position: absolute; inset:0; pointer-events:none; z-index:0; background-image: radial-gradient(circle at 12px 12px, rgba(2,8,23,0.06) 1px, transparent 1px); background-size: 24px 24px; }
          .caps-orb { position:absolute; width:260px; height:260px; border-radius:50%; filter: blur(12px); background: radial-gradient(circle at 40% 35%, rgba(238,0,0,0.28), rgba(238,0,0,0.08) 60%); animation: orbBreath 9s ease-in-out infinite; z-index:0; }
          .caps-orb-1 { top:-40px; left:-60px; } .caps-orb-2 { right:-80px; top:40%; width:220px; height:220px; } .caps-orb-3 { left:40%; bottom:-60px; width:160px; height:160px; }
          .caps-header { position:relative; text-align:center; z-index:2; }
          .caps-badge { margin-bottom:24px; display:inline-flex; align-items:center; gap:8px; padding:8px 18px; background:#fff; border:1px solid #e5e7eb; border-radius:99px; font-size:13px; font-weight:700; letter-spacing:.04em; box-shadow:0 8px 20px rgba(238,0,0,0.08); }
          .caps-badge-dot { width:6px; height:6px; border-radius:50%; background:#ee0000; animation: pulseRed 1.8s ease-in-out infinite; }
          .caps-title { margin-bottom:50px;font-size:42px; font-weight:800; color:#0f172a; }
          .caps-underline { width:120px; height:6px; background: linear-gradient(90deg,#ee0000,#f59e0b,#ee0000); border-radius:6px; margin:14px auto 0; }
          .caps-grid { margin-top:28px; }
          .caps-perspective { perspective: 1000px; }
          .caps-card { position:relative; background:#fff; border-radius:18px; border:1px solid #e6edf5; padding:22px; box-shadow:0 20px 60px -30px rgba(16,24,40,0.18); transform-style: preserve-3d; transition: transform .35s ease, box-shadow .35s ease; overflow:hidden; }
          .caps-card::before { content:""; position:absolute; left:0; right:0; top:0; height:4px; border-top-left-radius:18px; border-top-right-radius:18px; }
          .caps-card::after { content:""; position:absolute; inset:-20px -20px auto -20px; height:60px; opacity:0; z-index:0; transition: opacity .35s ease, filter .35s ease, transform .35s ease; transform: translateY(10px); filter: blur(18px); }
          .caps-card:hover { transform: translateY(-10px); box-shadow:0 32px 80px -28px rgba(238,0,0,0.35); }
          .caps-card:hover::after { opacity:1; transform: translateY(0); }
          .caps-accent { position:absolute; top:0; left:0; height:4px; width:100%;  }
          .caps-num-badge { position:absolute; top:12px; right:12px; width:34px; height:34px; background:#ffd6d6; color:#ee0000; display:flex; align-items:center; justify-content:center; font-weight:800; border-radius:50%; box-shadow:0 8px 24px rgba(238,0,0,0.15); z-index:2; }
          .caps-icon-wrap { position:relative; width:58px; height:58px; margin-bottom:12px; }
          .caps-icon-border { position:absolute; inset:-7px; border-radius:12px; border:2px solid rgba(238,0,0,0.35); transform: rotate(45deg); animation: rotateBorder 15s linear infinite; }
          .caps-icon-glow { position:absolute; inset:0; border-radius:12px; background: radial-gradient(circle at 35% 35%, rgba(238,0,0,0.16), rgba(238,0,0,0.04) 70%); }
          .caps-icon { position:absolute; inset:0; display:flex; align-items:center; justify-content:center; border-radius:12px; background:#ee0000; color:#fff; box-shadow: 0 12px 20px -8px rgba(238,0,0,0.55); transition: transform .6s ease; }
          .caps-card:hover .caps-icon { transform: rotate(360deg); }
          .caps-card-title { font-weight:800; font-size:18px; color:#0f172a; margin-top:30px; transition: color .25s; }
          .caps-card:hover .caps-card-title { color:#ee0000; }
          .caps-card-text { color:#374151; font-size:14px; margin:6px 0 0; }
          .caps-link { display:inline-flex; align-items:center; gap:6px; color:#ee0000; font-weight:700; opacity:0; transform: translateX(-6px); transition: opacity .35s ease, transform .35s ease; text-decoration:none; margin-top:8px; }
          .caps-card:hover .caps-link { opacity:1; transform: translateX(0); }
          .caps-link svg { transition: transform .35s ease; }
          .caps-card:hover .caps-link svg { transform: translateX(4px); }
          .caps-corner { position:absolute; bottom:0; right:0; width:80px; height:80px; opacity:0; transition: opacity .4s ease; pointer-events:none; }
          .caps-card:hover .caps-corner { opacity:1; }
          .caps-shine { position:absolute; inset:0; pointer-events:none; background: linear-gradient(120deg, transparent 30%, rgba(255,255,255,0.8) 50%, transparent 70%); transform: translateX(-100%); animation: shineSweep 8s ease-in-out infinite; opacity: 0.4; }
          @keyframes shineSweep { 0% { transform: translateX(-120%); } 20% { transform: translateX(120%); } 100% { transform: translateX(120%); } }
          .caps-footer-dots { display:flex; gap:12px; justify-content:center; margin-top:28px; }
          .caps-footer-dot { width:8px; height:8px; border-radius:50%; background:#ffd6d6; animation: footerPulse 2.6s ease-in-out infinite; }
          .caps-footer-dot:nth-child(2) { animation-delay: .3s; }
          .caps-footer-dot:nth-child(3) { animation-delay: .6s; }
          @keyframes rotateBorder { 0% { transform: rotate(45deg); } 100% { transform: rotate(405deg); } }
        `}
        </style>
        <section className="caps-section">
          <Container>
            <div className="caps-header">
              <motion.div className="caps-badge">
                <span className="caps-badge-dot" /> CAPABILITIES
              </motion.div>
              <motion.h2 className="caps-title">Key Capabilities</motion.h2>
            </div>
            <div className="caps-grid caps-perspective">
              <Row className="justify-content-center">
                {[
                  {
                    title: "Middleware-Backed by Design",
                    text: "All interactions flow through the Custom Middleware Platform—no fragile point-to-point connections.",
                    icon: "Layers",
                    num: "01",
                  },
                  {
                    title: "Secure by Default",
                    text: "Authentication, authorization, encryption, and policies are enforced centrally.",
                    icon: "Shield",
                    num: "02",
                  },
                  {
                    title: "Cross-Platform Ready",
                    text: "Works across Android, iOS, Web, and Desktop Flutter apps.",
                    icon: "Globe",
                    num: "03",
                  },
                  {
                    title: "Developer-Friendly",
                    text: "Clean Dart APIs aligned with Flutter best practices.",
                    icon: "Code",
                    num: "04",
                  },
                  {
                    title: "Built to Scale",
                    text: "Backend systems can evolve without impacting the application.",
                    icon: "Zap",
                    num: "05",
                  },
                ].map((item, idx) => (
                  <Col key={item.title} lg={4} md={6} className="mb-4 d-flex">
                    <motion.div
                      className="caps-card w-100"
                      style={{ perspective: 1000 }}
                    >
                      <div className="caps-accent" />
                      <div className="caps-icon-wrap">
                        <div className="caps-icon-border" />
                        <div className="caps-icon-glow" />
                        <div className="caps-icon">
                          {item.icon === "Layers" && <Layers size={22} />}
                          {item.icon === "Shield" && <Shield size={22} />}
                          {item.icon === "Globe" && <Globe size={22} />}
                          {item.icon === "Code" && <Code size={22} />}
                          {item.icon === "Zap" && <Zap size={22} />}
                        </div>
                      </div>
                      <div className="caps-shine" />
                      <h3 className="caps-card-title">{item.title}</h3>
                      <p className="caps-card-text">{item.text}</p>
                    </motion.div>
                  </Col>
                ))}
              </Row>
            </div>
          </Container>
        </section>

        <section className="usecases-section">
          <div className="uc-grid-overlay"></div>
          <div className="uc-orb uc-orb-1"></div>
          <div className="uc-orb uc-orb-2"></div>
          <div className="uc-rotating-square"></div>
          <Container>
            <div
              className="text-center position-relative"
              style={{ zIndex: 2 }}
            >
              <div className="sdk-badge">
                <span className="sdk-badge-dot"></span> USE CASES
              </div>
              <motion.h2 className="sdk-title">Common Use Cases</motion.h2>
            </div>
            <Row className="mt-4" style={{ position: "relative", zIndex: 2 }}>
              {[
                "Mobile apps consuming CRM and customer data",
                "Real-time personalization and engagement",
                "Secure analytics and reporting access",
                "Commerce and transaction workflows",
                "Legacy system access via modern APIs",
              ].map((title, i) => (
                <Col key={i} lg={3} className="mb-3 d-flex">
                  <motion.div className="feature-card uc-card w-100">
                    <span
                      className="uc-vertical-accent"
                      style={{ animationDelay: `${i * 0.1}s` }}
                    />
                    <div className="feature-icon-row">
                      <div className="feature-icon-wrapper">
                        <div className="icon-squircle-border"></div>
                        <div className="icon-squircle-bg"></div>
                        <div className="feature-icon-inner">
                          <Database size={26} />
                        </div>
                      </div>
                    </div>
                    <div className="mt-2">
                      <div className="feature-title">{title}</div>
                    </div>
                    <svg
                      className="card-corner-shape"
                      viewBox="0 0 100 100"
                      preserveAspectRatio="none"
                    >
                      <path
                        d="M0,100 C40,60 60,40 100,0 L100,100 Z"
                        fill="rgba(238,0,0,0.08)"
                      />
                    </svg>
                  </motion.div>
                </Col>
              ))}
            </Row>
          </Container>
        </section>

        <section className="benefits-section">
          <div className="benefit-grid-overlay"></div>
          <div className="benefit-orb benefit-orb-1"></div>
          <div className="benefit-orb benefit-orb-2"></div>
          <div className="benefit-floating-circle"></div>
          <div className="benefit-rotating-square"></div>
          <Container>
            <div
              className="text-center position-relative"
              style={{ zIndex: 2 }}
            >
              <div className="sdk-badge">
                <span className="sdk-badge-dot"></span> BENEFITS
              </div>
              <motion.h2 className="sdk-title">Benefits at a Glance</motion.h2>
            </div>
            <Row className="mt-4" style={{ position: "relative", zIndex: 2 }}>
              {[
                "Decoupled application architecture",
                "Enterprise-grade security and governance",
                "Faster development and releases",
                "Full visibility and control",
              ].map((title, i) => (
                <Col key={i} lg={3} md={6} className="mb-3 d-flex">
                  <motion.div className="benefit-card w-100">
                    <span
                      className="benefit-top-accent"
                      style={{ animationDelay: `${i * 0.1}s` }}
                    />
                    <div className="benefit-icon-wrapper">
                      <span className="benefit-icon-bg"></span>
                      <span className="benefit-icon-glow"></span>
                      <span className="icon-ring-border"></span>
                      <div className="benefit-icon-inner">
                        <CheckCircle2 size={26} />
                      </div>
                    </div>
                    <div className="mt-1">
                      <div className="feature-title">{title}</div>
                    </div>
                    <svg
                      className="card-corner-shape"
                      viewBox="0 0 100 100"
                      preserveAspectRatio="none"
                    >
                      <path
                        d="M0,100 C40,60 60,40 100,0 L100,100 Z"
                        fill="rgba(238,0,0,0.08)"
                      />
                    </svg>
                  </motion.div>
                </Col>
              ))}
            </Row>
          </Container>
        </section>

        <section className="resources-section">
          <div className="res-grid-overlay"></div>
          <div className="res-orb res-orb-1"></div>
          <div className="res-orb res-orb-2"></div>
          <div className="res-floating-circle"></div>
          <div className="res-rotating-square"></div>
          <Container>
            <div
              className="text-center position-relative"
              style={{ zIndex: 2 }}
            >
              <div className="sdk-badge">
                <span className="sdk-badge-dot"></span> RESOURCES
              </div>
              <motion.h2 className="sdk-title">Resources</motion.h2>
            </div>
            <Row className="mt-4" style={{ position: "relative", zIndex: 2 }}>
              {[
                { title: "Developer Documentation", icon: "Book", num: "01" },
                { title: "API Reference", icon: "FileText", num: "02" },
                { title: "Sample Apps", icon: "Code2", num: "03" },
                { title: "Release Notes", icon: "Download", num: "04" },
                { title: "Support", icon: "Phone", num: "05" },
              ].map((item, i) => (
                <Col key={item.title} className="mb-3 d-flex res-col">
                  <motion.div className="res-card w-100">
                    <span
                      className="res-top-accent"
                      style={{ animationDelay: `${i * 0.08}s` }}
                    />
                    <div className="res-icon-wrapper">
                      <span className="res-icon-bg"></span>
                      <span className="res-icon-glow"></span>
                      <span className="res-icon-ring"></span>
                      <div className="res-icon-inner">
                        {item.icon === "Book" && <Book size={22} />}
                        {item.icon === "FileText" && <FileText size={22} />}
                        {item.icon === "Code2" && <Code2 size={22} />}
                        {item.icon === "Download" && <Download size={22} />}
                        {item.icon === "Phone" && <Phone size={22} />}
                      </div>
                    </div>
                    <div className="mt-1 d-flex justify-content-between align-items-center">
                      <div className="feature-title mb-0">{item.title}</div>
                    </div>
                    <svg
                      className="card-corner-left"
                      viewBox="0 0 100 100"
                      preserveAspectRatio="none"
                    >
                      <path
                        d="M0,100 C40,60 60,40 100,0 L0,0 Z"
                        fill="rgba(238,0,0,0.08)"
                      />
                    </svg>
                  </motion.div>
                </Col>
              ))}
            </Row>
          </Container>
        </section>

        <section className="team-section">
          <div className="team-grid-overlay"></div>
          <div className="team-orb team-orb-1"></div>
          <div className="team-orb team-orb-2"></div>
          <div className="team-floating-circle"></div>
          <div className="team-rotating-square"></div>
          <Container>
            <div
              className="text-center position-relative"
              style={{ zIndex: 2 }}
            >
              <div className="sdk-badge">
                <span className="sdk-badge-dot"></span> TEAM BENEFITS
              </div>
              <motion.h2 className="sdk-title">
                Built for Growing Teams
              </motion.h2>
            </div>
            <Row className="mt-3" style={{ position: "relative", zIndex: 2 }}>
              {[
                "Minimal app-side code",
                "Configuration-driven integrations",
                "Reduced maintenance overhead",
                "Long-term architectural stability",
              ].map((title, i) => (
                <Col key={title} lg={3} md={12} className="mb-3 d-flex">
                  <motion.div className="team-card w-100">
                    <span
                      className="team-left-accent"
                      style={{ animationDelay: `${i * 0.12}s` }}
                    />
                    <div className="team-icon-wrapper">
                      <span className="team-icon-bg"></span>
                      <span className="team-icon-glow"></span>
                      <span className="team-icon-ring"></span>
                      <div className="team-icon-inner">
                        <CheckCircle2 size={22} />
                      </div>
                    </div>
                    <div className="flex-grow-1 position-relative">
                      <div className="team-title-text">{title}</div>
                    </div>
                    <div className="team-shine" />
                    <svg
                      className="team-corner-shape"
                      viewBox="0 0 100 100"
                      preserveAspectRatio="none"
                    >
                      <path
                        d="M0,100 C40,60 60,40 100,0 L100,100 Z"
                        fill="rgba(238,0,0,0.08)"
                      />
                    </svg>
                  </motion.div>
                </Col>
              ))}
            </Row>
          </Container>
        </section>

        <section className="cta-section">
          <div className="cta-orb cta-orb-left"></div>
          <div className="cta-orb cta-orb-right"></div>
          <Container>
            <div
              className="text-center position-relative"
              style={{ zIndex: 2 }}
            >
              <div className="cta-badge">
                <span className="sdk-badge-dot"></span> GET STARTED TODAY
              </div>
              <motion.h2
                className="cta-title"
                initial={{ opacity: 0, y: 18 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6 }}
              >
                Ready to Get Started?
              </motion.h2>
              <p className="cta-sub">
                Connect Flutter applications to Salesforce MCP through a secure,
                scalable middleware layer.
              </p>
              <div className="cta-buttons">
                <Link
                  to="/contact"
                  className="btn-cta-red"
                  style={{ textDecoration: "none" }}
                >
                  Request SDK Access <ArrowRight size={18} />
                </Link>
                <Link
                  to="/contact"
                  className="btn-cta-outline"
                  style={{ textDecoration: "none" }}
                >
                  View Documentation <ArrowRight size={18} />
                </Link>
                <Link
                  to="/contact"
                  className="btn-cta-outline"
                  style={{ textDecoration: "none" }}
                >
                  Contact Us <ArrowRight size={18} />
                </Link>
              </div>
            </div>
          </Container>
        </section>
      </div>
    </>
  );
};

export default FlutterSDK;
